import { library } from "@fortawesome/fontawesome-svg-core";
import {faHandHoldingDollar,  faMoneyBillTransfer} from "@fortawesome/free-solid-svg-icons"
library.add(faMoneyBillTransfer,faHandHoldingDollar)